import gjsBasicBlocks from 'grapesjs-blocks-basic';
import gjsPresetWebpage from 'grapesjs-preset-webpage';

import { EditorConfig } from 'grapesjs';
import { panelsConfig } from './panels';
import { stylesConfig } from './styles';
import { traitsConfig } from './traits';
import { pasteTextOnly } from '../plugins';
import { deviceManagerConfig } from './deviceManager';

// Объединяем все конфигурации в одну
export const editorConfig: Partial<EditorConfig> = {
  height: '100vh',
  width: 'auto',

  // Стили применяются к конкретному компоненту
  selectorManager: {
    componentFirst: true,
  },

  // Включаем плагины
  plugins: [gjsBasicBlocks, gjsPresetWebpage, pasteTextOnly],

  // Подключаем модульные конфигурации
  deviceManager: deviceManagerConfig,
  panels: panelsConfig,
  styleManager: stylesConfig,
  traitManager: traitsConfig,
};
